<template>
  <div>
    <p class="text-forgot">{{$t('forgot_password')}}</p>
    <v-container :style="(!$vuetify.breakpoint.xs) ? 'max-width: 100%; position: relative;' : 'position: relative;'">
      <v-text-field v-model="operation" :label="$t('operation')" outlined></v-text-field>
      <v-btn
        color="#1C1133"
        class="btn-reset white--text text-transform-none"
        elevation="2"
        block
        @click="requestPasswordReset()"
        :loading="loading"
        :disabled="loading"
      >
        {{$t('send_reset_link').toUpperCase()}}
      </v-btn>
      <div class="back d-flex flex-row-reverse mt-7">
        <a href="#" class="return-link" @click.prevent="$emit('returnLogin')">{{$t('return_to_login')}}</a>
      </div>
    </v-container>
  </div>
</template>

<script>
import sharedMethods from '../../mixins/sharedMethods';

export default {
  name: 'ForgotPassword',
  mixins: [sharedMethods],
  data() {
    return {
      operation: '',
      loading: false,
    }
  },
  created() {
    if(localStorage.getItem("operation")) {
      this.operation = localStorage.getItem("operation");
    }
  },
  methods: {
    async requestPasswordReset() {
      if (!this.operation) {
        this.$emit('showSnackbarError', this.$t('fill_all_fields'));
        return;
      }

      this.loading = true;
      let formData = new FormData();
      formData.append("operation", this.operation.toLowerCase());
      formData.append("action", "request");

      try {
        const url = this.baseUrl + 'server/password_reset.php';
        const headers = { headers: { "Content-Type": "multipart/form-data" } };
        const result = await this.axios.post(url, formData, headers);

        if(result?.data?.code){
          this.validateCode(result?.data?.code)
        }

      } catch (error) {
        console.error(error);
        this.$emit('showSnackbarError', this.$t('error_occurred'));
      } finally {
        this.loading = false;
      }
    },
    validateCode(code){
      if(code == 200){
        this.$emit('showSnackbarError', this.$t('reset_link_sent'));
      }else if(code == 404){
        this.$emit('showSnackbarError', this.$t('operation_not_found'));
      }else{
        this.$emit('showSnackbarError', this.$t('error_occurred'));
      }
    }
  }
}
</script>

<style scoped>
.text-forgot {
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  margin-bottom: 20px;
}
.validate {
  margin: auto;
  width: 100%;
  margin-top: 30px;
}
.btn-reset {
  letter-spacing: 0.5px !important;
  font-weight: 500 !important;
  height: 45px !important;
}
.return-link {
  color: #1C1133;
  text-decoration: none;
  font-weight: 600;
  font-size: 13px;
}
.return-link:hover {
  text-decoration: underline;
}
</style>
